import type { MandateStatus } from "@/types/mandate";

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatINR(n?: number | string | null): string {
  const num = Number(n);
  const safeNum = Number.isFinite(num) ? num : 0;
  return `\u20B9${safeNum.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(iso?: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });
}

export function formatTime(iso?: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });
}

export function formatDateTime(iso?: string | null): string {
  if (!iso) return "—";
  return `${formatDate(iso)}, ${formatTime(iso)}`;
}

export function relativeTime(iso?: string | null): string {
  if (!iso) return "Never";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "Never";
  const diff = Date.now() - then;
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} minute${mins === 1 ? "" : "s"} ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs === 1 ? "" : "s"} ago`;
  const days = Math.floor(hrs / 24);
  if (days === 1) return "yesterday";
  if (days < 30) return `${days} days ago`;
  return formatDate(iso);
}

export const RANGES = [
  "Today",
  "Last 7 Days",
  "Last 30 Days",
  "This Month",
  "Last 3 Months",
  "Custom Range",
];

export const DEFAULT_RANGE = "Last 30 Days";

export const RETAILER_OPTIONS: { value: string; label: string }[] = [];

export const EVENT_TYPE_OPTIONS = [
  "Mandate Created",
  "Status Updated",
  "Link Sent",
  "Link Opened",
  "Webhook Received",
  "Sync Performed",
  "Cancelled",
  "Admin Action",
].map((e) => ({ value: e, label: e }));

export const SOURCE_OPTIONS = [
  "Retailer Panel",
  "Admin Panel",
  "Provider API",
  "Webhook",
  "Cron Job",
].map((s) => ({ value: s, label: s }));

export const DEFAULT_LOG_RANGE = "Last 7 Days";

export interface StatusSlice {
  status: MandateStatus;
  value: number;
  color: string;
}